import React from "react";

const founders = [
  {
    initials: "MR",
    name: "Mevin Ramasamy",
    role: "CO-FOUNDER",
    paras: [
      "[Placeholder bio — edit freely. e.g. background in luxury hospitality and operations across the Indian Ocean, with nearly two decades of experience leading teams and building guest experiences rooted in genuine human connection.]",
      "[Placeholder — what Mevin brings to Verisaya: operational insight, an entrepreneurial mindset, and a focus on building products people actually trust and enjoy using.]",
    ],
  },
  {
    initials: "N",
    name: "Nadi",
    role: "CO-FOUNDER",
    paras: [
      "[Placeholder bio — add Nadi's full name and background here. e.g. professional experience, area of expertise, and what drew them to building Verisaya.]",
      "[Placeholder — what Nadi brings to Verisaya: their complementary strengths, the part of the business they lead, and their vision for the product.]",
    ],
  },
];

export default function Founders() {
  return (
    <div style={s.page}>
      <style>{`
        .fd-grid {
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:24px;
          margin-bottom:32px;
        }
        @media(max-width:640px){
          .fd-grid { grid-template-columns:1fr; }
        }
      `}</style>

      <p style={s.label}>THE FOUNDERS</p>
      <h1 style={s.heading}>The people behind <strong>Verisaya</strong>.</h1>
      <p style={s.sub}>
        Two founders united by a belief that presence should be simple to prove and impossible to fake.
      </p>

      <div className="fd-grid">
        {founders.map((f) => (
          <div key={f.name} style={s.card}>
            <div style={s.avatar}>{f.initials}</div>
            <h2 style={s.name}>{f.name}</h2>
            <p style={s.role}>{f.role}</p>
            {f.paras.map((p, i) => (
              <div key={i} style={s.block}>
                <div style={s.bar} />
                <p style={s.para}>{p}</p>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={s.block}>
        <div style={s.bar} />
        <p style={s.notePara}>
          [Optional placeholder — a shared founder note. How you two met, why you decided to build this together, and what you're setting out to do.]
        </p>
      </div>
    </div>
  );
}

const s = {
  page:     { background:"#080d20", minHeight:"100vh", padding:"clamp(40px,6vw,60px) clamp(20px,10%,120px)", color:"#c8d6e5", fontFamily:"'Segoe UI', sans-serif" },
  label:    { fontSize:12, letterSpacing:2, color:"#998046", textTransform:"uppercase", margin:"0 0 14px" },
  heading:  { fontSize:"clamp(26px,5vw,42px)", fontWeight:300, color:"#e8f0fa", margin:"0 0 16px", lineHeight:1.2 },
  sub:      { fontSize:14, color:"#868fa2", margin:"0 0 40px", maxWidth:480, lineHeight:1.6 },
  card:     { background:"#13202D", border:"1px solid #1e2e45", borderRadius:12, padding:"28px 24px" },
  avatar:   { width:48, height:48, borderRadius:"50%", border:"1px solid #998046", background:"#080d20", color:"#998046", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, fontWeight:700, marginBottom:16 },
  name:     { fontSize:18, fontWeight:700, color:"#e8f0fa", margin:"0 0 4px" },
  role:     { fontSize:11, letterSpacing:2, color:"#998046", textTransform:"uppercase", margin:"0 0 16px" },
  block:    { display:"flex", gap:12, marginBottom:14 },
  bar:      { width:3, background:"#998046", borderRadius:2, flexShrink:0 },
  para:     { fontSize:13, color:"#868fa2", fontStyle:"italic", lineHeight:1.75, margin:0 },
  notePara: { fontSize:13, color:"#868fa2", fontStyle:"italic", lineHeight:1.75, margin:0 },
};
